import {CustomError, ErrorPresentModes, ErrorSeverities} from "@kta20-core/errors/custom-error";
import {en as T} from "@kta20-core/resources/lang/en"; //here is safe to use english only

export class OfflineError extends CustomError {
    constructor(message?) {
        super(message ? (message + ' [err: OFFLINEE]') : T.no_network_connection_available);
        this.name = 'OfflineError';
        this.presentMode = ErrorPresentModes.DETAILS_TO_USER;
        this.severity = ErrorSeverities.RECOVERABLE;
    }
}